module.exports = __webpack_public_path__ + "static/media/home2.ef2edec7.jpg";